export default function LightIcon() {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M72 54.8571C72.016 50.5778 70.8875 46.3719 68.7314 42.6754C66.5753 38.9788 63.4701 35.926 59.7374 33.8332C56.0046 31.7403 51.7802 30.6836 47.5017 30.7724C43.2233 30.8613 39.0464 32.0925 35.4038 34.3386C31.7612 36.5846 28.7854 39.7637 26.7846 43.5466C24.7839 47.3295 23.831 51.5786 24.0247 55.8536C24.2184 60.1286 25.5516 64.2741 27.8863 67.8605C30.2209 71.447 33.472 74.344 37.3028 76.2514V88.0457C37.3207 88.743 37.6103 89.4057 38.1099 89.8925C38.6095 90.3793 39.2796 90.6516 39.9771 90.6514H56.0228C56.7204 90.6516 57.3904 90.3793 57.89 89.8925C58.3896 89.4057 58.6792 88.743 58.6971 88.0457V76.0457C62.6485 74.0787 65.9809 71.0601 68.3278 67.3219C70.6748 63.5837 71.9454 59.2707 72 54.8571Z"
        stroke="white"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48 5.55426V15.84M75.4286 15.36L68.16 22.6971M91.0628 36.6171H80.7771M20.5714 15.36L27.84 22.6971M4.93713 36.6171H15.2228"
        stroke="url(#paint0_linear_920_6849)"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_920_6849"
          x1="4.97334"
          y1="21.1861"
          x2="91.0724"
          y2="21.1861"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
      </defs>
    </svg>
  );
}
